import(/* webpackMode: "eager" */ "/home/ubuntu/csa-carspares/Shubh-ecom-frontend/src/app/privacy-policy/page.jsx");
